import React, { useEffect } from "react";
import marabotIcon from "../../assets/images/marabot_icon.png";

interface CustomToastProps {
    message: string;
    type?: "success" | "error" | "warning" | "info" | "welcome";
}

const CustomToast: React.FC<CustomToastProps> = ({ message, type }) => {
    // Only the post-login welcome toast scrolls the page to the top so the
    // greeting is in view. Error/validation toasts must NOT scroll — doing so
    // jerks the page (e.g. the listing screen behind the slideshow dialog) to
    // the top whenever a validation message fires.
    useEffect(() => {
        if (type === "welcome") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [type]);

    return (
        <div className="flex items-center px-4 py-3 rounded-md">
            {type === "welcome" ? (
                <img
                    src={marabotIcon}
                    alt="Marabot"
                    style={{
                        width: "40px",
                        height: "40px",
                        marginRight: "10px",
                    }}
                />
            ) : null}
            <span
                className={`${
                    type === "welcome"
                        ? "text-base font-semibold text-black"
                        : "text-sm"
                }`}
            >
                {message}
            </span>
        </div>
    );
};

export default CustomToast;
